module.exports = __webpack_public_path__ + "static/img/cabecera5.f614d45b.jpg";